// MG Product Swatches export: page Swatch Picker sections
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-WNP02"] = {
  "meta": {
    "appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "topcoat_labels": false,
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "row_height_mobile": 0,
      "row_height_desktop": 0,
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "more_popup_text": "More",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_image_index_overrides": [
        100,
        100,
        100,
        100,
        100
      ],
      "swatch_vertical_justify": "bottom",
      "swatch_row": true,
      "row_justify": "center",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "popup_padding_between_rows": 0,
      "button_switch": false,
      "preset_button": false,
      "preset_hide_modal_header": false,
      "preset_button_style": "dropdown_box",
      "preset_button_image_height_mobile": 0,
      "preset_button_image_height_desktop": 0,
      "preset_button_width_percent": 0,
      "preset_button_max_width_px": 0,
      "preset_button_padding_x_px": 0,
      "preset_button_padding_y_px": 0,
      "preset_button_heading_justify": "center",
      "preset_button_border_size": 1,
      "preset_button_shadow_size": 0,
      "preset_button_border_radius_px": 4,
      "preset_button_gradient_angle": 180,
      "preset_button_background_image_style": "center",
      "preset_button_text_size_mobile": 0,
      "preset_button_text_size_desktop": 0,
      "preset_button_text_behavior": "wrap_text",
      "preset_button_text_style": "normal",
      "preset_button_image_radius_px": 4,
      "preset_button_product_image_padding": 0,
      "preset_button_border_scope": "image_text",
      "collapsed": false,
      "show_more_text": "Show more",
      "show_less_text": "Show less",
      "row_toggle_border_style": "solid",
      "hide_cta_buttons": false,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Light Wood",
          "alt": "Light Wood",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/InFrontOfSwatch_79c77b88-c4b7-46f5-a14f-7f72c13cc8af.png?v=1791580575&width=400",
          "product_url": "/products/wnp_lite_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_lite_xxs",
            "text": "Shop"
          },
          "swatch_image_size_percent": 100,
          "swatchImageSizePercent": 100,
          "swatchVerticalJustify": "bottom"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bleached Wood",
          "alt": "Bleached Wood",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/InFrontOfSwatch.png?v=1791580432&width=400",
          "product_url": "/products/wnp_blch_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_blch_xxs",
            "text": "Shop"
          },
          "swatch_image_size_percent": 100,
          "swatchImageSizePercent": 100,
          "swatchVerticalJustify": "bottom"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Wood",
          "alt": "Dark Wood",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/InFrontOfSwatch_3cb78162-1145-40b3-bef4-2e2aa076d80d.png?v=1791580502&width=400",
          "product_url": "/products/wnp_dark_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_dark_xxs",
            "text": "Shop"
          },
          "swatch_image_size_percent": 100,
          "swatchImageSizePercent": 100,
          "swatchVerticalJustify": "bottom"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNP08"] = {
  "meta": {
    "appearance": {
      "border_color": "#767676",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "transparent",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 20,
      "text_size_desktop": 30,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 2,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 10,
      "background_color": "transparent",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 20,
      "text_size_desktop": 30,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Light",
          "alt": "Light",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-LITE-Swatch.png?v=1774696052&width=400",
          "product_url": "/products/wnp_lite_s",
          "product_id": 7573368045702,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$19.99",
          "price_num": 19.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_lite_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bleached",
          "alt": "Bleached",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-BLCH-Swatch.png?v=1774696620&width=400",
          "product_url": "/products/wnp_blch_s",
          "product_id": 7572896022662,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$19.99",
          "price_num": 19.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_blch_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark",
          "alt": "Dark",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-DARK-Swatch.png?v=1774696814&width=400",
          "product_url": "/products/wnp_dark_s",
          "product_id": 7572906639494,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$19.99",
          "price_num": 19.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_dark_s",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNP16"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNP08"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Light",
          "alt": "Light",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP16-LITE-Swatch.png?v=1774696133&width=400",
          "product_url": "/products/woodn-primer",
          "product_id": 6546153701510,
          "price": "$34.99",
          "price_num": 34.99,
          "available": true,
          "cta": {
            "href": "/products/woodn-primer",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bleached",
          "alt": "Bleached",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW16-BLCH-8.png?v=1774460968&width=400",
          "product_url": "/products/woodn-primer-bleached",
          "product_id": 6863197798534,
          "price": "$34.99",
          "price_num": 34.99,
          "available": true,
          "cta": {
            "href": "/products/woodn-primer-bleached",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark",
          "alt": "Dark",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-DARK-SWATCH_0ab62acd-b630-4ddf-a502-c9a8da46d945.png?v=1774696812&width=400",
          "product_url": "/products/woodn-primer-dark",
          "product_id": 6863197405318,
          "price": "$34.99",
          "price_num": 34.99,
          "available": true,
          "cta": {
            "href": "/products/woodn-primer-dark",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNP32"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNP08"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Light",
          "alt": "Light",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-LITE-Swatch.png?v=1775298061&width=400",
          "product_url": "/products/wnp_lite_l",
          "product_id": 7573368144006,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_lite_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bleached",
          "alt": "Bleached",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/L-WNP-BLCH-new-8.png?v=1774696616&width=400",
          "product_url": "/products/wnp_blch_l",
          "product_id": 7572896088198,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_blch_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark",
          "alt": "Dark",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-DARK-SWATCH.png?v=1774696817&width=400",
          "product_url": "/products/wnp_dark_l",
          "product_id": 7572906705030,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_dark_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNP128"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNP08"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Light",
          "alt": "Light",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-Swatch.png?v=1774700579&width=400",
          "product_url": "/products/wnp_lite_xl",
          "product_id": 7573368176774,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_lite_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bleached",
          "alt": "Bleached",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-BLCH-8.png?v=1774696614&width=400",
          "product_url": "/products/wnp_blch_xl",
          "product_id": 7572896120966,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_blch_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark",
          "alt": "Dark",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-DARK-SWATCH.png?v=1774696822&width=400",
          "product_url": "/products/wnp_dark_xl",
          "product_id": 7572906770566,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_dark_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNP-LITE"] = {
  "meta": {
    "appearance": {
      "border_color": "#767676",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 20,
      "text_size_desktop": 30,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 2,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 20,
      "text_size_desktop": 30,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h2>Light Wood Size Options</h2>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 40,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "85",
          "scale": "85",
          "product_image_scale": "85",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-LITE-3D.png?v=1774695981&width=400",
          "product_url": "/products/wnp_lite_s",
          "product_id": 7573368045702,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$19.99",
          "price_num": 19.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_lite_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "55",
          "scale": "55",
          "product_image_scale": "55",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/S-WNP-DARK-new-1.png?v=1773261059&width=400",
          "product_url": "/products/woodn-primer",
          "product_id": 6546153701510,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$34.99",
          "price_num": 34.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodn-primer",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-LITE-2D.png?v=1775295918&width=400",
          "product_url": "/products/wnp_lite_l",
          "product_id": 7573368144006,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_lite_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-2D.png?v=1774700579&width=400",
          "product_url": "/products/wnp_lite_xl",
          "product_id": 7573368176774,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_lite_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "subheading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426180230__mg_product_swatches_dhzph7-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz (Jar) - 25 square feet</li>\n    <li>16 oz (Pt) - 50 square feet</li>\n    <li>32 oz (Qt) - 100 square feet</li>\n    <li>128 oz (Gal) - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": "0",
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h2>More Help on Sizes</h2>",
      "preset_button_set": "Help-WNP-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 0,
      "preset_button_max_width_px": "0",
      "heading": "<h2>More Help on Sizes</h2>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNP-BLCH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNP-LITE"
  },
  "rows": [
    {
      "heading": "<h2>Bleached Wood Size Options</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-BLCH-2D.png?v=1774637593&width=400",
          "product_url": "/products/wnp_blch_s",
          "product_id": 7572896022662,
          "price": "$19.99",
          "price_num": 19.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_blch_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "85",
          "scale": "85",
          "product_image_scale": "85"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/S-WNP-BLCH-new-1.png?v=1773261175&width=400",
          "product_url": "/products/woodn-primer-bleached",
          "product_id": 6863197798534,
          "price": "$34.99",
          "price_num": 34.99,
          "available": true,
          "cta": {
            "href": "/products/woodn-primer-bleached",
            "text": "Shop"
          },
          "swatch_image_zoom": "55",
          "scale": "55",
          "product_image_scale": "55"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/L-WNP-BLCH-new-1_1e700a26-22db-4ca5-8c2d-09ca5fbee8fd.png?v=1774615696&width=400",
          "product_url": "/products/wnp_blch_l",
          "product_id": 7572896088198,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_blch_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-BLCH-1_cabc697c-6c0f-438d-8c2c-8cf004e567b6.png?v=1774616531&width=400",
          "product_url": "/products/wnp_blch_xl",
          "product_id": 7572896120966,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_blch_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18541426180230__mg_product_swatches_jPLDKM-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8oz - 25 square feet</li>\n    <li>16oz - 50 square feet</li>\n    <li>32oz - 100 square feet</li>\n    <li>Gal - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h2>More Help on Sizes</h2>",
      "preset_button_set": "Help-WNP-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 0,
      "preset_button_max_width_px": "0",
      "heading": "<h2>More Help on Sizes</h2>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNP-DARK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNP-LITE"
  },
  "rows": [
    {
      "heading": "<h2>Dark Wood Size Options</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-DARK-3D.png?v=1774652644&width=400",
          "product_url": "/products/wnp_dark_s",
          "product_id": 7572906639494,
          "price": "$19.99",
          "price_num": 19.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_dark_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "85",
          "scale": "85",
          "product_image_scale": "85"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/S-WNP-DARK-new-1_3ff90f25-935b-4491-8db3-ebc237f6d1e7.png?v=1773261273&width=400",
          "product_url": "/products/woodn-primer-dark",
          "product_id": 6863197405318,
          "price": "$34.99",
          "price_num": 34.99,
          "available": true,
          "cta": {
            "href": "/products/woodn-primer-dark",
            "text": "Shop"
          },
          "swatch_image_zoom": "55",
          "scale": "55",
          "product_image_scale": "55"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-DARK-3D.png?v=1774651833&width=400",
          "product_url": "/products/wnp_dark_l",
          "product_id": 7572906705030,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_dark_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-DARK-1_b4c7fc37-9cb7-4f3e-8999-5419feebf023.png?v=1774623890&width=400",
          "product_url": "/products/wnp_dark_xl",
          "product_id": 7572906770566,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/wnp_dark_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18541426180230__mg_product_swatches_a9HMYC-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz (Jar) - 25 square feet</li>\n    <li>16 oz (Pt) - 50 square feet</li>\n    <li>32 oz (Qt) - 100 square feet</li>\n    <li>128 oz (Gal) - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<p>More Help on Sizes</p>",
      "preset_button_set": "Help-WNP-Sizes",
      "preset_button_style": "button",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 50,
      "preset_button_max_width_px": "0",
      "heading": "<p>More Help on Sizes</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};